import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { getApi, postApi, putApi } from "../../utils/api";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import { toggleMenu } from "../../utils/helpers";
import PageTitle from "../../components/PageTitle";
import NumberRadioCheckbox from "../../components/Performance/NumberRadioCheckbox";
import CharLimitTextArea from "../../components/Performance/CharLimitTextArea";
import RangedNumberRadioCheckbox from "../../components/Performance/RangedNumberRadioCheckbox";
import { useMemo } from "react";
import axios from "axios";
import {
  API_GET_PERFORMANCE,
  API_PERFORMANCE_SUBMIT,
} from "../../config/Endpoints";
import ConfirmationModal from "../../components/ConfirmationModal";
import { performance } from "../../data";
import ReadOnlyPerformance from "../../components/Performance/ReadOnlyPerformance";
import PerformanceNavigation from "../../components/Performance/PerformanceNavigation";
import * as Yup from "yup";
import validations from "../../config/validation";

const PerformanceV2 = ({ title, description }) => {
  const user = JSON.parse(localStorage.getItem("userData"));
  const isArchitect =
    user.designation === "Assosicate Solution Architect" ||
    user.designation === "Solution Architect";

  const [isFormCompletelyFilled, setIsFormCompletelyFilled] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formDataInitialState = {
    certifications: {
      associate: [],
      administrator: [],
      architect: [],
      consultant: [],
      developer: [],
    },
    otherCertifications: "",
    exercisesCompleted: [],
    mockInterviewsGiven: 0,
    mockInterviewDetails: "",
    expertLedSessionsPresented: "",
    coffeeNLearnSessions: "",
    isMuleSoftMeetupSpeaker: false,
    meetupDetails: "",
    eventDetails: "",
    isMuleSoftMeetupLeader: false,
    isMuleSoftMentor: false,
    isMuleSoftAmbassador: false,
    salesforceSessionsPresented: "",
    completedCaeliusAIEnablementProgram: false,
    trainingBuddyAssisted: "",
    mentorLeadAssisted: "",
    reviewsTaken: "",
    projectsUndertaken: 0,
    projects: "",
    codeReviewsTaken: "",
    codeReviewsTakenArchitect: "",
    architecturalSolutionsDesigned: "",
    achievements: "",
    csatScore5Projects: "",
    selfAssessment: {
      jobSkills: 0,
      technicalSkills: 0,
      responsiveness: 0,
      communicationSkills: 0,
      teamwork: 0,
      flexibility: 0,
      inclusiveness: 0,
      initiative: 0,
    },
    initiativeDetails: "",
    trainingDevelopmentNeeds: "",
    additionalInfo: "",
  };
  const [formData, setFormData] = useState(formDataInitialState);
  const accessToken = Cookies.get("accessToken");
  const formRef = useRef(null);
  const [errors, setErrors] = useState("");

  const validationSchema = Yup.object().shape({
    otherCertifications: validations.PERFORMANCE_TEXTAREA,
    mockInterviewDetails: validations.PERFORMANCE_TEXTAREA,
    coffeeNLearnSessions: validations.PERFORMANCE_TEXTAREA,
    meetupDetails: validations.PERFORMANCE_TEXTAREA,
    eventDetails: validations.PERFORMANCE_TEXTAREA,
    trainingBuddyAssisted: validations.PERFORMANCE_TEXTAREA,
    mentorLeadAssisted: validations.PERFORMANCE_TEXTAREA,
    reviewsTaken: validations.PERFORMANCE_TEXTAREA,
    codeReviewsTaken: validations.PERFORMANCE_TEXTAREA,
    achievements: validations.PERFORMANCE_TEXTAREA,
    csatScore5Projects: validations.PERFORMANCE_TEXTAREA,
    projects: validations.PERFORMANCE_TEXTAREA,
    initiativeDetails: validations.PERFORMANCE_TEXTAREA,
    trainingDevelopmentNeeds: validations.PERFORMANCE_TEXTAREA,
    additionalInfo: validations.PERFORMANCE_TEXTAREA,
    architecturalSolutionsDesigned: validations.PERFORMANCE_TEXTAREA,
    codeReviewsTakenArchitect: validations.PERFORMANCE_TEXTAREA,
  });

  const sections = performance.sections;

  const sectionRefs = {};
  sections.forEach((section) => {
    sectionRefs[section] = React.createRef();
  });

  const getPerformanceData = async () => {
    setIsPageLoading(true);
    try {
      await getApi(API_GET_PERFORMANCE, accessToken)
        .then((res) => {
          setIsFormSubmitted(res.data.data.isSubmitted || false);
          mapPerformanceDataResponseToFormData(res.data.data.performanceData);
          setData(res.data.data.performanceData);
        })
        .catch((err) => {
          toast.error(
            err.response.data.message ||
              "Something went wrong please try again later.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        });
    } catch (error) {
    } finally {
      setIsPageLoading(false);
    }
  };

  const mapPerformanceDataResponseToFormData = (response) => {
    const newFormData = {
      certifications: {
        associate: response.certifications.associate.answer,
        administrator: response.certifications.administrator.answer,
        architect: response.certifications.architect.answer,
        consultant: response.certifications.consultant.answer,
        developer: response.certifications.developer.answer,
      },
      otherCertifications: response.otherCertifications.answer,
      exercisesCompleted: response.exercisesCompleted.answer,
      mockInterviewsGiven: response.mockInterviewsGiven.answer,
      mockInterviewDetails: response.mockInterviewDetails.answer,
      expertLedSessionsPresented: response.expertLedSessionsPresented.answer,
      coffeeNLearnSessions: response.coffeeNLearnSessions.answer,
      isMuleSoftMeetupSpeaker: response.isMuleSoftMeetupSpeaker.answer,
      meetupDetails: response.meetupDetails.answer,
      eventDetails: response.eventDetails.answer,
      isMuleSoftMeetupLeader: response.isMuleSoftMeetupLeader.answer,
      isMuleSoftMentor: response.isMuleSoftMentor.answer,
      isMuleSoftAmbassador: response.isMuleSoftAmbassador.answer,
      salesforceSessionsPresented: response.salesforceSessionsPresented.answer,
      completedCaeliusAIEnablementProgram:
        response.completedCaeliusAIEnablementProgram.answer,
      trainingBuddyAssisted: response.trainingBuddyAssisted.answer,
      mentorLeadAssisted: response.mentorLeadAssisted.answer,
      reviewsTaken: response.reviewsTaken.answer,
      projectsUndertaken: response.projectsUndertaken.answer,
      projects: response.projects.answer,
      codeReviewsTaken: response.codeReviewsTaken.answer,
      codeReviewsTakenArchitect: response.codeReviewsTakenArchitect.answer,
      architecturalSolutionsDesigned:
        response.architecturalSolutionsDesigned.answer,
      achievements: response.achievements.answer,
      csatScore5Projects: response.csatScore5Projects.answer,
      selfAssessment: {
        jobSkills: response.selfAssessment.jobSkills.answer,
        technicalSkills: response.selfAssessment.technicalSkills.answer,
        responsiveness: response.selfAssessment.responsiveness.answer,
        communicationSkills: response.selfAssessment.communicationSkills.answer,
        teamwork: response.selfAssessment.teamwork.answer,
        flexibility: response.selfAssessment.flexibility.answer,
        inclusiveness: response.selfAssessment.inclusiveness.answer,
        initiative: response.selfAssessment.initiative.answer,
      },
      initiativeDetails: response.initiativeDetails.answer,
      trainingDevelopmentNeeds: response.trainingDevelopmentNeeds.answer,
      additionalInfo: response.additionalInfo.answer,
    };

    setFormData(newFormData);
  };

  useEffect(() => {
    getPerformanceData();
  }, []);

  const handleScrollToUnansweredQuestion = () => {
    const ids = [
      "otherCertifications",
      "mockInterviewsGiven",
      "mockInterviewDetails",
      "expertLedSessionsPresented",
      "coffeeNLearnSessions",
      "meetupDetails",
      "eventDetails",
      "meetupDetails",
      "salesforceSessionsPresented",
      "trainingBuddyAssisted",
      "mentorLeadAssisted",
      "projectsUndertaken",
      "projects",
      "codeReviewsTaken",
      "achievements",
      "csatScore5Projects",
      "initiativeDetails",
      "trainingDevelopmentNeeds",
      "additionalInfo",
      "codeReviewsTakenArchitect",
      "architecturalSolutionsDesigned",
    ];

    const selfAssessmentIds = [
      "jobSkills",
      "technicalSkills",
      "responsiveness",
      "communicationSkills",
      "teamwork",
      "flexibility",
      "inclusiveness",
      "initiative",
    ];

    const idsMatch = ids.some((id) => {
      if (formData[id].toString() === formDataInitialState[id].toString()) {
        const element = document.getElementById(`q-${id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          return true;
        }

        return false;
      }
    });

    const selfAssessmentIdsMatch = selfAssessmentIds.some((id) => {
      if (
        formData.selfAssessment[id].toString() ===
        formDataInitialState.selfAssessment[id].toString()
      ) {
        const element = document.getElementById(`q-${id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          return true;
        }

        return false;
      }
    });
  };

  const checkIsFormCompletelyFilled = () => {
    return (
      formData.mockInterviewsGiven !==
        formDataInitialState.mockInterviewsGiven &&
      formData.expertLedSessionsPresented !==
        formDataInitialState.expertLedSessionsPresented &&
      formData.salesforceSessionsPresented !==
        formDataInitialState.salesforceSessionsPresented &&
      formData.projectsUndertaken !== formDataInitialState.projectsUndertaken &&
      formData.selfAssessment.jobSkills !==
        formDataInitialState.selfAssessment.jobSkills &&
      formData.selfAssessment.technicalSkills !==
        formDataInitialState.selfAssessment.technicalSkills &&
      formData.selfAssessment.responsiveness !==
        formDataInitialState.selfAssessment.responsiveness &&
      formData.selfAssessment.communicationSkills !==
        formDataInitialState.selfAssessment.communicationSkills &&
      formData.selfAssessment.teamwork !==
        formDataInitialState.selfAssessment.teamwork &&
      formData.selfAssessment.flexibility !==
        formDataInitialState.selfAssessment.flexibility &&
      formData.selfAssessment.inclusiveness !==
        formDataInitialState.selfAssessment.inclusiveness &&
      formData.selfAssessment.initiative !==
        formDataInitialState.selfAssessment.initiative &&
      formData.otherCertifications !==
        formDataInitialState.otherCertifications &&
      formData.mockInterviewDetails !==
        formDataInitialState.mockInterviewDetails &&
      formData.expertLedSessionsPresented !==
        formDataInitialState.expertLedSessionsPresented &&
      formData.coffeeNLearnSessions !==
        formDataInitialState.coffeeNLearnSessions &&
      formData.meetupDetails !== formDataInitialState.meetupDetails &&
      formData.eventDetails !== formDataInitialState.eventDetails &&
      formData.trainingBuddyAssisted !==
        formDataInitialState.trainingBuddyAssisted &&
      formData.mentorLeadAssisted !== formDataInitialState.mentorLeadAssisted &&
      formData.reviewsTaken !== formDataInitialState.reviewsTaken &&
      formData.projects !== formDataInitialState.projects &&
      formData.codeReviewsTaken !== formDataInitialState.codeReviewsTaken &&
      formData.achievements !== formDataInitialState.achievements &&
      formData.csatScore5Projects !== formDataInitialState.csatScore5Projects &&
      formData.initiativeDetails !== formDataInitialState.initiativeDetails &&
      formData.trainingDevelopmentNeeds !==
        formDataInitialState.trainingDevelopmentNeeds &&
      formData.additionalInfo !== formDataInitialState.additionalInfo &&
      formData.codeReviewsTakenArchitect !==
        formDataInitialState.codeReviewsTakenArchitect &&
      formData.architecturalSolutionsDesigned !==
        formDataInitialState.architecturalSolutionsDesigned
    );
  };

  useEffect(() => {
    const isFormCompletelyFilled = checkIsFormCompletelyFilled();

    setIsFormCompletelyFilled(isFormCompletelyFilled);
  }, [formData]);

  const handleSaveAsDraft = async (e) => {
    e.preventDefault();

    setIsSavingDraft(true);
    try {
      await axios
        .post(API_PERFORMANCE_SUBMIT + "?isSubmitted=0", formData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          toast.success("Form saved successfully.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .catch((err) => {
          toast.error("Error saving form.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    } catch (error) {
      toast.error("Error saving form.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsSavingDraft(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checkIsFormCompletelyFilled()) {
      handleScrollToUnansweredQuestion();

      return;
    }

    try {
      await validationSchema.validate(formData, {
        abortEarly: false,
      });

      const confirmModal = document.getElementById("performanceConfirmModal");
      const modal = new window.bootstrap.Modal(confirmModal);
      modal.show();
    } catch (error) {
      const validationErrors = {};
      error?.inner?.forEach((err) => {
        validationErrors[err.path] = err.message;
      });
      setErrors(validationErrors);
      toast.error("Some fields have errors.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const submitPerformanceForm = async (e) => {
    setIsSubmitting(true);
    try {
      await axios
        .post(API_PERFORMANCE_SUBMIT + "?isSubmitted=1", formData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          toast.success(res.data || "Form submitted successfully.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .catch((err) => {
          toast.error(
            err.response.data || "Something went wrong please try again later.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        });
    } catch (error) {
    } finally {
      const confirmModal = document.getElementById("performanceConfirmModal");
      const modal = window.bootstrap.Modal.getInstance(confirmModal);
      modal?.hide();
      setIsSubmitting(false);
      handleReset();
    }
  };

  const handleCertificationSelect = (e, category) => {
    const { value, checked } = e.target;

    if (value === "None") {
      setFormData((prev) => ({
        ...prev,
        certifications: {
          ...prev.certifications,
          [category]: [],
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        certifications: {
          ...prev.certifications,
          [category]: checked
            ? [...prev.certifications[category], value]
            : prev.certifications[category].filter((item) => item !== value),
        },
      }));
    }
  };

  const handleExerciseSelect = (e) => {
    const { value, checked } = e.target;

    if (value === "None") {
      setFormData((prev) => ({
        ...prev,
        exercisesCompleted: [],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        exercisesCompleted: checked
          ? [...prev.exercisesCompleted, value]
          : prev.exercisesCompleted.filter((item) => item !== value),
      }));
    }
  };

  const handleSelfAssessmentSelect = (e) => {
    const { value, name } = e.target;

    setFormData((prev) => ({
      ...prev,
      selfAssessment: {
        ...prev.selfAssessment,
        [name]: parseInt(value),
      },
    }));
  };

  const handleChange = (e, type) => {
    const { name, value } = e.target;

    switch (type) {
      case "number":
        setFormData((prev) => ({ ...prev, [name]: parseInt(value) }));
        break;
      case "boolean":
        setFormData((prev) => ({ ...prev, [name]: value === "true" }));
        break;
      default:
        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleReset = () => {
    setIsLoading(false);
    setIsSavingDraft(false);
    setIsSubmitting(false);
    setIsPageLoading(false);
    getPerformanceData();
    setErrors({});
  };

  const sectionData = performance.sectionData;

  return (
    <div className="wrapper-body">
      {isPageLoading && (
        <div className="overlay">
          <div className="mt-5">
            <ThreeDots
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}

      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        {!isFormSubmitted && (
          <ActionButtons
            isSavingDraft={isSavingDraft}
            isSubmitting={isSubmitting}
            handleSaveAsDraft={handleSaveAsDraft}
          />
        )}
      </div>
      {!isPageLoading && (
        <div className="row">
          <PerformanceNavigation sectionRefs={sectionRefs} />
          {isFormSubmitted ? (
            <ReadOnlyPerformance data={data} sectionRefs={sectionRefs} />
          ) : (
            <div className="col-md-9">
              <form
                id="performanceEvaluationForm"
                ref={formRef}
                onSubmit={handleSubmit}
              >
                {/* BEGIN: TRAINING & ENABLEMENT */}
                <section id={sections[0]} ref={sectionRefs[sections[0]]}>
                  <div className="card">
                    <h2 className="heading">{sections[0]}</h2>
                    <p>
                      <span className="d-block">
                        {sectionData[sections[0]].description}
                      </span>
                    </p>

                    <div className="d-f f-w inputs gap-15">
                      <div className="input-group">
                        <label htmlFor="certifications" className="question">
                          {sectionData[sections[0]].questions[0]}
                        </label>
                        <div
                          id="certifications"
                          className="d-flex flex-column gap-4"
                        >
                          {/* Associate Certifications */}
                          <div>
                            <label htmlFor="associate-certifications">
                              Associate
                            </label>
                            <div
                              className="custom-checkbox"
                              id="associate-certifications"
                            >
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertAssociate"
                                  value="Salesforce Certified Associate"
                                  checked={formData.certifications.associate.includes(
                                    "Salesforce Certified Associate"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "associate")
                                  }
                                />
                                <label htmlFor="check_sfCertAssociate">
                                  Salesforce Certified Associate
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertMuleAssociate"
                                  value="Salesforce Certified MuleSoft Associate"
                                  checked={formData.certifications.associate.includes(
                                    "Salesforce Certified MuleSoft Associate"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "associate")
                                  }
                                />
                                <label htmlFor="check_sfCertMuleAssociate">
                                  Salesforce Certified MuleSoft Associate
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertAIAssociate"
                                  value="Salesforce Certified AI Associate"
                                  checked={formData.certifications.associate.includes(
                                    "Salesforce Certified AI Associate"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "associate")
                                  }
                                />
                                <label htmlFor="check_sfCertAIAssociate">
                                  Salesforce Certified AI Associate
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertAssociateNone"
                                  value="None"
                                  checked={
                                    formData.certifications.associate
                                      ?.length === 0
                                  }
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "associate")
                                  }
                                />
                                <label htmlFor="check_sfCertAssociateNone">
                                  None
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Administrator Certifications */}
                          <div>
                            <label htmlFor="associate-certifications">
                              Administrator
                            </label>
                            <div
                              className="custom-checkbox"
                              id="associate-certifications"
                            >
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertAdministrator"
                                  value="Salesforce Certified Administrator"
                                  checked={formData.certifications.administrator.includes(
                                    "Salesforce Certified Administrator"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(
                                      e,
                                      "administrator"
                                    )
                                  }
                                />
                                <label htmlFor="check_sfCertAdministrator">
                                  Salesforce Certified Administrator
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertAdvancedAdministrator"
                                  value="Salesforce Certified Advanced Administrator"
                                  checked={formData.certifications.administrator.includes(
                                    "Salesforce Certified Advanced Administrator"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(
                                      e,
                                      "administrator"
                                    )
                                  }
                                />
                                <label htmlFor="check_sfCertAdvancedAdministrator">
                                  Salesforce Certified Advanced Administrator
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertBusinessAnalyst"
                                  value="Salesforce Certified Business Analyst"
                                  checked={formData.certifications.administrator.includes(
                                    "Salesforce Certified Business Analyst"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(
                                      e,
                                      "administrator"
                                    )
                                  }
                                />
                                <label htmlFor="check_sfCertBusinessAnalyst">
                                  Salesforce Certified Business Analyst
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertAdministratorNone"
                                  value="None"
                                  checked={
                                    formData.certifications.administrator
                                      .length === 0
                                  }
                                  onChange={(e) =>
                                    handleCertificationSelect(
                                      e,
                                      "administrator"
                                    )
                                  }
                                />
                                <label htmlFor="check_sfCertAdministratorNone">
                                  None
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Architect Certifications */}
                          <div>
                            <label htmlFor="associate-certifications">
                              Architect{" "}
                            </label>
                            <div
                              className="custom-checkbox"
                              id="associate-certifications"
                            >
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertIntegrationArchitect"
                                  value="Salesforce Certified Integration Architect"
                                  checked={formData.certifications.architect.includes(
                                    "Salesforce Certified Integration Architect"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "architect")
                                  }
                                />
                                <label htmlFor="check_sfCertIntegrationArchitect">
                                  Salesforce Certified Integration Architect
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertMuleIntegrationArchitectI"
                                  value="Salesforce Certified MuleSoft Integration Architect I"
                                  checked={formData.certifications.architect.includes(
                                    "Salesforce Certified MuleSoft Integration Architect I"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "architect")
                                  }
                                />
                                <label htmlFor="check_sfCertMuleIntegrationArchitectI">
                                  Salesforce Certified MuleSoft Integration
                                  Architect I
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertMulePlatformArchitectI"
                                  value="Salesforce Certified MuleSoft Platform Architect I"
                                  checked={formData.certifications.architect.includes(
                                    "Salesforce Certified MuleSoft Platform Architect I"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "architect")
                                  }
                                />
                                <label htmlFor="check_sfCertMulePlatformArchitectI">
                                  Salesforce Certified MuleSoft Platform
                                  Architect I
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertCatalystSpecialist"
                                  value="Salesforce Certified Catalyst Specialist"
                                  checked={formData.certifications.architect.includes(
                                    "Salesforce Certified Catalyst Specialist"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "architect")
                                  }
                                />
                                <label htmlFor="check_sfCertCatalystSpecialist">
                                  Salesforce Certified Catalyst Specialist
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertArchitectNone"
                                  value="None"
                                  checked={
                                    formData.certifications.architect.length ===
                                    0
                                  }
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "architect")
                                  }
                                />
                                <label htmlFor="check_sfCertArchitectNone">
                                  None
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Consultant Certifications */}
                          <div>
                            <label htmlFor="associate-certifications">
                              Consultant{" "}
                            </label>
                            <div
                              className="custom-checkbox"
                              id="associate-certifications"
                            >
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertSalesCloudConsultant"
                                  value="Salesforce Certified Sales Cloud Consultant"
                                  checked={formData.certifications.consultant.includes(
                                    "Salesforce Certified Sales Cloud Consultant"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "consultant")
                                  }
                                />
                                <label htmlFor="check_sfCertSalesCloudConsultant">
                                  Salesforce Certified Sales Cloud Consultant
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertServiceCloudConsultant"
                                  value="Salesforce Certified Service Cloud Consultant"
                                  checked={formData.certifications.consultant.includes(
                                    "Salesforce Certified Service Cloud Consultant"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "consultant")
                                  }
                                />
                                <label htmlFor="check_sfCertServiceCloudConsultant">
                                  Salesforce Certified Service Cloud Consultant
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertDataCloudConsultant"
                                  value="Salesforce Certified Data Cloud Consultant"
                                  checked={formData.certifications.consultant.includes(
                                    "Salesforce Certified Data Cloud Consultant"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "consultant")
                                  }
                                />
                                <label htmlFor="check_sfCertDataCloudConsultant">
                                  Salesforce Certified Data Cloud Consultant
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertOmniStudioConsultant"
                                  value="Salesforce Certified OmniStudio Consultant"
                                  checked={formData.certifications.consultant.includes(
                                    "Salesforce Certified OmniStudio Consultant"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "consultant")
                                  }
                                />
                                <label htmlFor="check_sfCertOmniStudioConsultant">
                                  Salesforce Certified OmniStudio Consultant
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertConsultantNone"
                                  value="None"
                                  checked={
                                    formData.certifications.consultant
                                      .length === 0
                                  }
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "consultant")
                                  }
                                />
                                <label htmlFor="check_sfCertConsultantNone">
                                  None
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Developer Certifications */}
                          <div>
                            <label htmlFor="associate-certifications">
                              Developer{" "}
                            </label>
                            <div
                              className="custom-checkbox"
                              id="associate-certifications"
                            >
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertPlatformDeveloperI"
                                  value="Salesforce Certified Platform Developer I"
                                  checked={formData.certifications.developer.includes(
                                    "Salesforce Certified Platform Developer I"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "developer")
                                  }
                                />
                                <label htmlFor="check_sfCertPlatformDeveloperI">
                                  Salesforce Certified Platform Developer I
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertMuleDeveloperI"
                                  value="Salesforce Certified MuleSoft Developer I"
                                  checked={formData.certifications.developer.includes(
                                    "Salesforce Certified MuleSoft Developer I"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "developer")
                                  }
                                />
                                <label htmlFor="check_sfCertMuleDeveloperI">
                                  Salesforce Certified MuleSoft Developer I
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertMuleDeveloperII"
                                  value="Salesforce Certified MuleSoft Developer II"
                                  checked={formData.certifications.developer.includes(
                                    "Salesforce Certified MuleSoft Developer II"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "developer")
                                  }
                                />
                                <label htmlFor="check_sfCertMuleDeveloperII">
                                  Salesforce Certified MuleSoft Developer II
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertHyperautomationSpecialist"
                                  value="Salesforce Certified Hyperautomation Specialist"
                                  checked={formData.certifications.developer.includes(
                                    "Salesforce Certified Hyperautomation Specialist"
                                  )}
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "developer")
                                  }
                                />
                                <label htmlFor="check_sfCertHyperautomationSpecialist">
                                  Salesforce Certified Hyperautomation
                                  Specialist
                                </label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="check_sfCertDeveloperNone"
                                  value="None"
                                  checked={
                                    formData.certifications.developer.length ===
                                    0
                                  }
                                  onChange={(e) =>
                                    handleCertificationSelect(e, "developer")
                                  }
                                />
                                <label htmlFor="check_sfCertDeveloperNone">
                                  None
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-otherCertifications"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="otherCertifications"
                        >
                          {sectionData[sections[0]].questions[1]}
                        </label>
                        <div>
                          {errors.otherCertifications && (
                            <small className="text-danger">
                              {errors.otherCertifications}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="otherCertifications"
                          name="otherCertifications"
                          value={formData.otherCertifications}
                          onChange={handleChange}
                          lengthParam={formData.otherCertifications.length}
                          maxLength={5000}
                          rows={6}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15 mt-4">
                      <div className="input-group">
                        <label
                          htmlFor="exercisesCompleted"
                          className="question"
                        >
                          {sectionData[sections[0]].questions[2]}
                        </label>
                        <div
                          className="custom-checkbox small"
                          id="exercisesCompleted"
                        >
                          <div>
                            <input
                              type="checkbox"
                              id="check_exerciseDW"
                              onChange={handleExerciseSelect}
                              checked={formData.exercisesCompleted.includes(
                                "Dataweave Exercises"
                              )}
                              value="Dataweave Exercises"
                            />
                            <label htmlFor="check_exerciseDW">
                              Dataweave Exercises
                            </label>
                          </div>
                          <div>
                            <input
                              type="checkbox"
                              id="check_exerciseMindtickle"
                              onChange={handleExerciseSelect}
                              checked={formData.exercisesCompleted.includes(
                                "Mindtickle"
                              )}
                              value="Mindtickle"
                            />
                            <label htmlFor="check_exerciseMindtickle">
                              Mindtickle
                            </label>
                          </div>
                          <div>
                            <input
                              type="checkbox"
                              id="check_exerciseScenarioBased"
                              onChange={handleExerciseSelect}
                              checked={formData.exercisesCompleted.includes(
                                "Scenario Based Questions"
                              )}
                              value="Scenario Based Questions"
                            />
                            <label htmlFor="check_exerciseScenarioBased">
                              Scenario Based Questions
                            </label>
                          </div>
                          <div>
                            <input
                              type="checkbox"
                              id="check_exerciseNone"
                              onChange={handleExerciseSelect}
                              checked={formData.exercisesCompleted.length === 0}
                              value="None"
                            />
                            <label htmlFor="check_exerciseNone">None</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-mockInterviewsGiven"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="mockInterviewsGiven"
                        >
                          {sectionData[sections[0]].questions[3]}
                        </label>
                        <NumberRadioCheckbox
                          id="mockInterviewsGiven"
                          name="mockInterviewsGiven"
                          onChange={(e) => handleChange(e, "number")}
                          checkedParam={formData.mockInterviewsGiven}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-mockInterviewDetails"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="mockInterviewDetails"
                        >
                          {sectionData[sections[0]].questions[4]}
                        </label>
                        <div>
                          {errors.mockInterviewDetails && (
                            <small className="text-danger">
                              {errors.mockInterviewDetails}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="mockInterviewDetails"
                          name="mockInterviewDetails"
                          value={formData.mockInterviewDetails}
                          onChange={handleChange}
                          lengthParam={formData.mockInterviewDetails.length}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15 mt-4"
                      id="q-expertLedSessionsPresented"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="expertLedSessionsPresented"
                        >
                          {sectionData[sections[0]].questions[5]}
                        </label>
                        <RangedNumberRadioCheckbox
                          id="expertLedSessionsPresented"
                          name="expertLedSessionsPresented"
                          onChange={handleChange}
                          checkedParam={formData.expertLedSessionsPresented}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-coffeeNLearnSessions"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="coffeeNLearnSessions"
                        >
                          {sectionData[sections[0]].questions[6]}
                        </label>
                        <div>
                          {errors.coffeeNLearnSessions && (
                            <small className="text-danger">
                              {errors.coffeeNLearnSessions}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="coffeeNLearnSessions"
                          name="coffeeNLearnSessions"
                          value={formData.coffeeNLearnSessions}
                          onChange={handleChange}
                          lengthParam={formData.coffeeNLearnSessions.length}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15 mt-4">
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="isMuleSoftMeetupSpeaker"
                        >
                          {sectionData[sections[0]].questions[7]}
                        </label>
                        <YesNoRadioCheckbox
                          id="isMuleSoftMeetupSpeaker"
                          name="isMuleSoftMeetupSpeaker"
                          onChange={(e) => handleChange(e, "boolean")}
                          checkedParam={formData.isMuleSoftMeetupSpeaker}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-meetupDetails">
                      <div className="input-group">
                        <label className="question" htmlFor="meetupDetails">
                          {sectionData[sections[0]].questions[8]}
                        </label>
                        <div>
                          {errors.meetupDetails && (
                            <small className="text-danger">
                              {errors.meetupDetails}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="meetupDetails"
                          name="meetupDetails"
                          value={formData.meetupDetails}
                          onChange={handleChange}
                          lengthParam={formData.meetupDetails.length}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-eventDetails">
                      <div className="input-group">
                        <label className="question" htmlFor="eventDetails">
                          {sectionData[sections[0]].questions[9]}
                        </label>
                        <div>
                          {errors.eventDetails && (
                            <small className="text-danger">
                              {errors.eventDetails}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="eventDetails"
                          name="eventDetails"
                          value={formData.eventDetails}
                          onChange={handleChange}
                          lengthParam={formData.eventDetails.length}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15 mt-4">
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="isMuleSoftMeetupLeader"
                        >
                          {sectionData[sections[0]].questions[10]}
                        </label>
                        <YesNoRadioCheckbox
                          id="isMuleSoftMeetupLeader"
                          name="isMuleSoftMeetupLeader"
                          onChange={(e) => handleChange(e, "boolean")}
                          checkedParam={formData.isMuleSoftMeetupLeader}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15 mt-4">
                      <div className="input-group">
                        <label className="question" htmlFor="isMuleSoftMentor">
                          {sectionData[sections[0]].questions[11]}
                        </label>
                        <YesNoRadioCheckbox
                          id="isMuleSoftMentor"
                          name="isMuleSoftMentor"
                          onChange={(e) => handleChange(e, "boolean")}
                          checkedParam={formData.isMuleSoftMentor}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15 mt-4">
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="isMuleSoftAmbassador"
                        >
                          {sectionData[sections[0]].questions[12]}
                        </label>
                        <YesNoRadioCheckbox
                          id="isMuleSoftAmbassador"
                          name="isMuleSoftAmbassador"
                          onChange={(e) => handleChange(e, "boolean")}
                          checkedParam={formData.isMuleSoftAmbassador}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15 mt-4"
                      id="q-salesforceSessionsPresented"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="salesforceSessionsPresented"
                        >
                          {sectionData[sections[0]].questions[13]}
                        </label>
                        <RangedNumberRadioCheckbox
                          id="salesforceSessionsPresented"
                          name="salesforceSessionsPresented"
                          onChange={handleChange}
                          checkedParam={formData.salesforceSessionsPresented}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15 mt-4">
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="completedCaeliusAIEnablementProgram"
                        >
                          {sectionData[sections[0]].questions[14]}
                        </label>
                        <YesNoRadioCheckbox
                          id="completedCaeliusAIEnablementProgram"
                          name="completedCaeliusAIEnablementProgram"
                          onChange={(e) => handleChange(e, "boolean")}
                          checkedParam={
                            formData.completedCaeliusAIEnablementProgram
                          }
                        />
                      </div>
                    </div>
                  </div>
                </section>
                {/* END: TRAINING & ENABLEMENT */}

                {/* BEGIN: MENTORSHIP */}
                <section id={sections[1]} ref={sectionRefs[sections[1]]}>
                  <div className="card">
                    <h2 className="heading">{sections[1]}</h2>
                    <p>
                      <span className="d-block">
                        {sectionData[sections[1]].description}
                      </span>
                    </p>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-trainingBuddyAssisted"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="trainingBuddyAssisted"
                        >
                          {sectionData[sections[1]].questions[0]}
                        </label>
                        <div>
                          {errors.trainingBuddyAssisted && (
                            <small className="text-danger">
                              {errors.trainingBuddyAssisted}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="trainingBuddyAssisted"
                          name="trainingBuddyAssisted"
                          value={formData.trainingBuddyAssisted}
                          onChange={handleChange}
                          lengthParam={formData.trainingBuddyAssisted.length}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-mentorLeadAssisted"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="mentorLeadAssisted"
                        >
                          {sectionData[sections[1]].questions[1]}
                        </label>
                        <div>
                          {errors.mentorLeadAssisted && (
                            <small className="text-danger">
                              {errors.mentorLeadAssisted}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="mentorLeadAssisted"
                          name="mentorLeadAssisted"
                          value={formData.mentorLeadAssisted}
                          onChange={handleChange}
                          lengthParam={formData.mentorLeadAssisted.length}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-reviewsTaken">
                      <div className="input-group">
                        <label className="question" htmlFor="reviewsTaken">
                          {sectionData[sections[1]].questions[2]}
                        </label>
                        <div>
                          {errors.reviewsTaken && (
                            <small className="text-danger">
                              {errors.reviewsTaken}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="reviewsTaken"
                          name="reviewsTaken"
                          value={formData.reviewsTaken}
                          onChange={handleChange}
                          lengthParam={formData.reviewsTaken.length}
                        />
                      </div>
                    </div>
                  </div>
                </section>
                {/* END: MENTORSHIP */}

                {/* BEGIN: PROJECTS */}
                <section id={sections[2]} ref={sectionRefs[sections[2]]}>
                  <div className="card">
                    <h2 className="heading">{sections[2]}</h2>
                    <p>
                      <span className="d-block">
                        {sectionData[sections[2]].description}
                      </span>
                    </p>
                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-projectsUndertaken"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="projectsUndertaken"
                        >
                          {sectionData[sections[2]].questions[0]}
                        </label>
                        <NumberRadioCheckbox
                          id="projectsUndertaken"
                          name="projectsUndertaken"
                          onChange={(e) => handleChange(e, "number")}
                          checkedParam={formData.projectsUndertaken}
                          max={15}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-projects">
                      <div className="input-group">
                        <label className="question" htmlFor="projects">
                          {sectionData[sections[2]].questions[1]}
                        </label>
                        <div>
                          {errors.projects && (
                            <small className="text-danger">
                              {errors.projects}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="projects"
                          name="projects"
                          value={formData.projects}
                          onChange={handleChange}
                          rows="6"
                          maxLength={1000}
                          lengthParam={formData.projects.length}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-codeReviewsTaken"
                    >
                      <div className="input-group">
                        <label className="question" htmlFor="codeReviewsTaken">
                          {sectionData[sections[2]].questions[2]}
                        </label>
                        <div>
                          {errors.codeReviewsTaken && (
                            <small className="text-danger">
                              {errors.codeReviewsTaken}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="codeReviewsTaken"
                          name="codeReviewsTaken"
                          value={formData.codeReviewsTaken}
                          onChange={handleChange}
                          lengthParam={formData.codeReviewsTaken.length}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-codeReviewsTakenArchitect"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="codeReviewsTakenArchitect"
                        >
                          {sectionData[sections[2]].questions[3]}
                        </label>
                        <div>
                          {errors.codeReviewsTakenArchitect && (
                            <small className="text-danger">
                              {errors.codeReviewsTakenArchitect}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="codeReviewsTakenArchitect"
                          name="codeReviewsTakenArchitect"
                          required={isArchitect}
                          value={formData.codeReviewsTakenArchitect}
                          onChange={handleChange}
                          lengthParam={
                            formData.codeReviewsTakenArchitect.length
                          }
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-architecturalSolutionsDesigned"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="architecturalSolutionsDesigned"
                        >
                          {sectionData[sections[2]].questions[4]}
                        </label>
                        <div>
                          {errors.architecturalSolutionsDesigned && (
                            <small className="text-danger">
                              {errors.architecturalSolutionsDesigned}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="architecturalSolutionsDesigned"
                          name="architecturalSolutionsDesigned"
                          value={formData.architecturalSolutionsDesigned}
                          onChange={handleChange}
                          required={isArchitect}
                          rows={6}
                          maxLength={1000}
                          lengthParam={
                            formData.architecturalSolutionsDesigned.length
                          }
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-achievements">
                      <div className="input-group">
                        <label className="question" htmlFor="achievements">
                          {sectionData[sections[2]].questions[5]}
                        </label>
                        <div>
                          {errors.achievements && (
                            <small className="text-danger">
                              {errors.achievements}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="achievements"
                          name="achievements"
                          value={formData.achievements}
                          onChange={handleChange}
                          rows={5}
                          maxLength={500}
                          lengthParam={formData.achievements.length}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-csatScore5Projects"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="csatScore5Projects"
                        >
                          {sectionData[sections[2]].questions[6]}
                        </label>
                        <div>
                          {errors.csatScore5Projects && (
                            <small className="text-danger">
                              {errors.csatScore5Projects}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="csatScore5Projects"
                          name="csatScore5Projects"
                          value={formData.csatScore5Projects}
                          onChange={handleChange}
                          lengthParam={formData.csatScore5Projects.length}
                        />
                      </div>
                    </div>
                  </div>
                </section>
                {/* END: PROJECTS */}

                {/* BEGIN: GENERAL */}
                <section id={sections[3]} ref={sectionRefs[sections[3]]}>
                  <div className="card">
                    <h2 className="heading">{sections[3]}</h2>
                    <p>
                      <span className="d-block">
                        {sectionData[sections[3]].description}
                      </span>
                    </p>

                    <div className="d-f f-w inputs gap-15" id="q-jobSkills">
                      <div className="input-group">
                        <label className="question" htmlFor="jobSkills">
                          {sectionData[sections[3]].questions[0]}
                        </label>
                        <NumberRadioCheckbox
                          id="jobSkills"
                          name="jobSkills"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={formData.selfAssessment.jobSkills}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-technicalSkills"
                    >
                      <div className="input-group">
                        <label className="question" htmlFor="technicalSkills">
                          {sectionData[sections[3]].questions[1]}
                        </label>
                        <NumberRadioCheckbox
                          id="technicalSkills"
                          name="technicalSkills"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={formData.selfAssessment.technicalSkills}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-responsiveness"
                    >
                      <div className="input-group">
                        <label className="question" htmlFor="responsiveness">
                          {sectionData[sections[3]].questions[2]}
                        </label>
                        <NumberRadioCheckbox
                          id="responsiveness"
                          name="responsiveness"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={formData.selfAssessment.responsiveness}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-communicationSkills"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="communicationSkills"
                        >
                          {sectionData[sections[3]].questions[3]}
                        </label>
                        <NumberRadioCheckbox
                          id="communicationSkills"
                          name="communicationSkills"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={
                            formData.selfAssessment.communicationSkills
                          }
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-teamwork">
                      <div className="input-group">
                        <label className="question" htmlFor="teamwork">
                          {sectionData[sections[3]].questions[4]}
                        </label>
                        <NumberRadioCheckbox
                          id="teamwork"
                          name="teamwork"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={formData.selfAssessment.teamwork}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-flexibility">
                      <div className="input-group">
                        <label className="question" htmlFor="flexibility">
                          {sectionData[sections[3]].questions[5]}
                        </label>
                        <NumberRadioCheckbox
                          id="flexibility"
                          name="flexibility"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={formData.selfAssessment.flexibility}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-inclusiveness">
                      <div className="input-group">
                        <label className="question" htmlFor="inclusiveness">
                          {sectionData[sections[3]].questions[6]}
                        </label>
                        <NumberRadioCheckbox
                          id="inclusiveness"
                          name="inclusiveness"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={formData.selfAssessment.inclusiveness}
                        />
                      </div>
                    </div>

                    <div className="d-f f-w inputs gap-15" id="q-initiative">
                      <div className="input-group">
                        <label className="question" htmlFor="initiative">
                          {sectionData[sections[3]].questions[7]}
                        </label>
                        <NumberRadioCheckbox
                          id="initiative"
                          name="initiative"
                          onChange={handleSelfAssessmentSelect}
                          checkedParam={formData.selfAssessment.initiative}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-initiativeDetails"
                    >
                      <div className="input-group">
                        <label className="question" htmlFor="initiativeDetails">
                          {sectionData[sections[3]].questions[8]}
                        </label>
                        <div>
                          {errors.initiativeDetails && (
                            <small className="text-danger">
                              {errors.initiativeDetails}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="initiativeDetails"
                          name="initiativeDetails"
                          value={formData.initiativeDetails}
                          onChange={handleChange}
                          rows="5"
                          maxLength={500}
                          lengthParam={formData.initiativeDetails.length}
                        />
                      </div>
                    </div>
                  </div>
                </section>
                {/* END: GENERAL */}

                {/* BEGIN: TRAINING REQUIREMENTS */}
                <section id={sections[4]} ref={sectionRefs[sections[4]]}>
                  <div className="card">
                    <h2 className="heading">{sections[4]}</h2>
                    <p>
                      <span className="d-block">
                        {sectionData[sections[4]].description}
                      </span>
                    </p>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-trainingDevelopmentNeeds"
                    >
                      <div className="input-group">
                        <label
                          className="question"
                          htmlFor="trainingDevelopmentNeeds"
                        >
                          {sectionData[sections[4]].questions[0]}
                        </label>
                        <div>
                          {errors.trainingDevelopmentNeeds && (
                            <small className="text-danger">
                              {errors.trainingDevelopmentNeeds}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="trainingDevelopmentNeeds"
                          name="trainingDevelopmentNeeds"
                          value={formData.trainingDevelopmentNeeds}
                          onChange={handleChange}
                          rows="5"
                          maxLength={500}
                          lengthParam={formData.trainingDevelopmentNeeds.length}
                        />
                      </div>
                    </div>

                    <div
                      className="d-f f-w inputs gap-15"
                      id="q-additionalInfo"
                    >
                      <div className="input-group">
                        <label className="question" htmlFor="additionalInfo">
                          {sectionData[sections[4]].questions[1]}
                        </label>
                        <div>
                          {errors.additionalInfo && (
                            <small className="text-danger">
                              {errors.additionalInfo}
                            </small>
                          )}
                        </div>
                        <CharLimitTextArea
                          id="additionalInfo"
                          name="additionalInfo"
                          value={formData.additionalInfo}
                          onChange={handleChange}
                          lengthParam={formData.additionalInfo.length}
                        />
                      </div>
                    </div>
                  </div>
                </section>
                {/* END: TRAINING REQUIREMENTS */}
                <ActionButtons
                  isSavingDraft={isSavingDraft}
                  isSubmitting={isSubmitting}
                  handleSaveAsDraft={handleSaveAsDraft}
                />
              </form>
            </div>
          )}
        </div>
      )}

      <ConfirmationModal
        id="performanceConfirmModal"
        text="Are you sure you want submit the performance form?"
        onConfirm={submitPerformanceForm}
        isLoading={isSubmitting}
      />
    </div>
  );
};

const ActionButtons = ({
  isSavingDraft,
  isSubmitting,
  isLoading,
  handleSaveAsDraft,
}) => {
  return (
    <div className="d-flex gap-2">
      <button
        type="submit"
        onClick={handleSaveAsDraft}
        disabled={isSavingDraft || isSubmitting}
        className={isSavingDraft ? "theme-button disabled " : "theme-button"}
      >
        {isSavingDraft ? (
          <ThreeDots
            height="20"
            width="53"
            radius="9"
            color="white"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        ) : (
          "Save As Draft"
        )}
      </button>

      <button
        type="submit"
        form="performanceEvaluationForm"
        disabled={isSavingDraft || isSubmitting}
        className={isSubmitting ? "theme-button disabled " : "theme-button"}
      >
        {/* {isSubmitting ? (
          <ThreeDots
            height="20"
            width="53"
            radius="9"
            color="white"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        ) : (
          "Submit"
        )} */}
        Submit
      </button>
    </div>
  );
};

const YesNoRadioCheckbox = ({ id, name, onChange, checkedParam }) => {
  return (
    <div className="custom-checkbox small" id={id}>
      {[true, false].map((item, index) => {
        const value = item ? "Yes" : "No";
        return (
          <div key={`yesNo${id}${index}`}>
            <input
              type="radio"
              id={`check_${name}${value}`}
              name={name}
              value={item}
              checked={checkedParam === item}
              onChange={onChange}
            />
            <label htmlFor={`check_${name}${value}`}>{value}</label>
          </div>
        );
      })}
    </div>
  );
};

export default PerformanceV2;
